import React from "react";
import { createPortal } from "react-dom";
import { Heart, Megaphone, Lock, X } from "lucide-react";

export default function OptOutCautionDialog({ onCancel, onConfirm }) {
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60" data-testid="optout-caution-dialog" onMouseDown={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
      <div className="bg-card text-foreground border border-border rounded-xl shadow-2xl w-full max-w-lg overflow-hidden">
        <div className="flex items-start justify-between gap-3 px-6 py-4 border-b border-border">
          <div className="flex items-center gap-2">
            <span className="p-2 rounded-lg bg-amber-100 text-amber-700"><Heart className="h-5 w-5" /></span>
            <h3 className="font-serif text-xl tracking-tight">Before you opt out</h3>
          </div>
          <button data-testid="optout-caution-close" onClick={onCancel} className="p-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted"><X className="h-4 w-4" /></button>
        </div>
        <div className="px-6 py-5 space-y-4 text-sm leading-relaxed">
          <p>This is a <b>brand-new approach</b> to how our Alumni Association stays in touch — built to share reunions, classmate news, and the moments that matter, not to crowd your inbox. If past communications ever missed the mark, we hope you won't hold that against us.</p>
          <div className="flex gap-3 rounded-lg border border-border bg-muted/40 p-3">
            <Megaphone className="h-5 w-5 text-primary shrink-0 mt-0.5" />
            <p>If you'd still like to opt out, we'd be grateful if you'd <b>stay on our announcements list</b> — even if you turn off fundraising &amp; giving appeals — so you never miss a reunion or a fellow alumnus's news.</p>
          </div>
          <div className="flex gap-3 rounded-lg border border-border bg-muted/40 p-3">
            <Lock className="h-5 w-5 text-primary shrink-0 mt-0.5" />
            <p>Your privacy matters: <b>we will never sell or share your information.</b></p>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 px-6 py-4 border-t border-border bg-muted/30">
          <button data-testid="optout-caution-cancel" onClick={onCancel} className="px-4 py-2 rounded-md border border-border text-sm hover:bg-muted">Stay subscribed</button>
          <button data-testid="optout-caution-confirm" onClick={onConfirm} className="px-4 py-2 rounded-md bg-primary text-white text-sm font-medium hover:bg-primary/90">Opt out anyway</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
